var $ = require('jquery');
var SwiperModule = require('swiper');
var Swiper = SwiperModule.default || SwiperModule.Swiper || SwiperModule;
var Parallax = require('parallax-js');
var ScrollReveal = require('scrollreveal');
var lottie = require('lottie-web');

// Make jQuery available globally BEFORE requiring jQuery UI
window.$ = $;
window.jQuery = $;

// Now require jQuery UI and validation after jQuery is global
require('jquery-validation');
require('jquery-ui/ui/widget');
require('jquery-ui/ui/version');
require('jquery-ui/ui/keycode');
require('jquery-ui/ui/unique-id');
require('jquery-ui/ui/widgets/mouse');
require('jquery-ui/ui/widgets/slider');
require('jquery-ui');

// Debug flag - temporarily enabled by default
var DEBUG = true; // window.location.search.indexOf('debug=1') > -1 || window.location.search.indexOf('debug=true') > -1;

// Always log debug flag status
console.log('[MagicCube JS] Debug flag:', DEBUG);
console.log('[MagicCube JS] Search params:', window.location.search);
var FORM_ENDPOINT = 'https://formspree.io/f/mkbnynqx';
var MODAL_FORM_ENDPOINT = 'https://formspree.io/f/mkbnynqx';

// Simple test to verify JS is loading
console.log('MagicCube JS loaded successfully!');

function debugLog(msg, data) {
    if (DEBUG) {
        console.log('[MagicCube JS]', msg, data || '');
    }
}

function safe(fn, fallback) {
    try {
        return fn();
    } catch (e) {
        debugLog('Safe wrapper caught error', e);
        return fallback || undefined;
    }
}

function safeQuery(selector) {
    try {
        return $(selector);
    } catch (e) {
        debugLog('Query error for selector', selector);
        return $();
    }
}

function safeElement(selector) {
    try {
        var el = document.querySelector(selector);
        if (!el) debugLog('Element not found', selector);
        return el;
    } catch (e) {
        debugLog('Element query error', selector);
        return null;
    }
}

function ensureLib(name, lib) {
    if (!lib) {
        debugLog('Library missing', name);
        return false;
    }
    return true;
}

function ensurejQueryPlugin(name) {
    if (!$.fn || !$.fn[name]) {
        debugLog('jQuery plugin missing', name);
        return false;
    }
    return true;
}

function getBodyClasses() {
    var body = document.body;
    return body ? Array.from(body.classList) : [];
}

function hasPageClass(cls) {
    return getBodyClasses().indexOf(cls) !== -1;
}

function initWhenReady(name, fn) {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            debugLog('DOMContentLoaded init', name);
            safe(fn);
        });
    } else {
        debugLog('Immediate init', name);
        safe(fn);
    }
}

function debounce(func, wait) {
    var timeout;
    return function executedFunction() {
        var context = this;
        var args = arguments;
        var later = function () {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

function throttle(func, limit) {
    var inThrottle;
    return function () {
        var args = arguments;
        var context = this;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(function () { return inThrottle = false; }, limit);
        }
    };
}

function validateEmail(value) {
    return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9-]+\.[a-zA-Z.]{2,5}$/i.test(value);
}

function isPersonalEmail(email) {
    if (!email) return true;
    var lower = String(email).toLowerCase();
    return lower.endsWith('gmail.com') ||
        lower.endsWith('yahoo.com') ||
        lower.endsWith('hotmail.com') ||
        lower.endsWith('aol.com') ||
        lower.endsWith('outlook.com') ||
        lower.endsWith('zoho.com') ||
        lower.endsWith('mail.com') ||
        lower.endsWith('protonmail.com') ||
        lower.endsWith('icloud.com') ||
        lower.endsWith('gmx.com') ||
        lower.endsWith('yandex.com') ||
        lower.endsWith('sbcglobal.net');
}

function addValidationMethods() {
    if (!ensureLib('jQuery Validation', $.validator)) return;

    $.validator.addMethod('fullname', function () {
        return true;
    });

    $.validator.addMethod('emailAddress', function (value, element) {
        return this.optional(element) || validateEmail(value);
    }, 'Please enter a valid email address.');

    $.validator.addMethod('businessAccount', function (value, element) {
        return this.optional(element) || !isPersonalEmail(value);
    }, 'Please need corporate emails only.');

    debugLog('Validation methods added');
}

function submitAjaxForm($form, url, onSuccess) {
    if (!$form || !url) {
        debugLog('Invalid form submission args');
        return Promise.reject();
    }

    $form.addClass('loading');
    return $.ajax({
        url: url,
        data: $form.serialize(),
        dataType: 'json',
        type: 'post'
    }).done(function (res) {
        debugLog('Form submitted successfully', res);
        $form.removeClass('loading');
        if (onSuccess) onSuccess(res);
    }).fail(function (xhr, status, err) {
        debugLog('Form submission failed', { status: status, error: err });
        $form.removeClass('loading');
        $('.contact-main').addClass('error');
    });
}

function initGlobalMenus() {
    safeQuery('.toggle').on('click', function () {
        safeQuery('.toggle').attr('aria-expanded', 'true');
        var toggleIcon = safeQuery('#toggleIcon');

        if (toggleIcon.hasClass('is-active')) {
            safeQuery('.toggle').attr('aria-expanded', 'false');
        }

        safeQuery('.toggle-menu').fadeToggle(300, function () {
            toggleIcon.toggleClass('is-active');
        });
    });

    safeQuery('.products-menu_display').on('click', function (e) {
        e.preventDefault();
        var productsMenu = safeElement('.products-menu');
        if (!productsMenu) return;

        var expanded = productsMenu.getAttribute('aria-expanded') === 'true';
        productsMenu.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    });

    $(document).on('click', function (event) {
        if (!$(event.target).closest('.products-menu,.products-menu_display').length) {
            safeQuery('.products-menu').attr('aria-expanded', 'false');
        }
    });

    debugLog('Global menus initialized');
}

function initGlobalOverlayForms() {
    safeQuery('.form-display-javelin').on('click', function (e) {
        e.preventDefault();
        safeQuery('.overlay-javelin').fadeToggle();
    });

    $(window).on('click', function (event) {
        if (event.target.className && String(event.target.className).startsWith('overlay-')) {
            safeQuery('[class^="form-footer-"]').hide();
            safeQuery('[class^="form-fail-footer-"]').hide();
            $(event.target).hide();
        }
    });

    safeQuery('.closeContact').on('click', function (e) {
        e.preventDefault();
        safeQuery('[class^="form-fail-footer-"]').hide();
        safeQuery('[class^="overlay-"]').hide();
    });

    safeQuery('.demo-contact-form').on('submit', function (e) {
        e.preventDefault();
        var $form = $(this);
        var name = $form.find('.inputName').val();
        var email = $form.find('.inputEmail').val();
        var business = $form.find('.inputBusiness').val();

        if (!name || !business) {
            safeQuery('#text-error').text('Something went wrong. Please try later.');
            safeQuery('[class^="form-fail-footer-"]').fadeIn(200);
            return false;
        }

        if (isPersonalEmail(email)) {
            safeQuery('#text-error').text('Please need corporate emails only.');
            safeQuery('[class^="form-fail-footer-"]').fadeIn(200);
            return false;
        }

        $.ajax({
            method: 'post',
            url: MODAL_FORM_ENDPOINT,
            data: $form.serialize(),
            dataType: 'json'
        }).done(function () {
            debugLog('Demo form submitted');
            $form[0].reset();
            safeQuery('[class^="form-footer-"]').fadeIn();
            safeQuery('[class^="form-fail-footer-"]').fadeOut();
        }).fail(function () {
            debugLog('Demo form submission failed');
            $form[0].reset();
            safeQuery('[class^="form-footer-"]').fadeOut();
            safeQuery('[class^="form-fail-footer-"]').fadeIn();
        });

        return false;
    });

    debugLog('Global overlay forms initialized');
}

function initHome($body) {
    if (!safeElement('section.no-banner')) {
        $body.addClass('banner-active');
    }

    var scene = safeElement('#scene');
    if (scene && ensureLib('Parallax', window.Parallax)) {
        new Parallax(scene, {
            relativeInput: true,
            clipRelativeInput: false,
            calibrateX: true,
            calibrateY: true,
            invertX: false,
            invertY: true,
            limitX: false,
            limitY: true,
            scalarX: 4,
            scalarY: 1,
            frictionX: 1,
            frictionY: 1,
            originX: 0.6,
            originY: 1,
            precision: 1,
            pointerEvents: false
        });
        debugLog('Parallax initialized');
    }

    if (ensurejQueryPlugin('fancybox')) {
        safeQuery('[data-fancybox="gallery"]').fancybox();
        debugLog('Fancybox initialized');
    }
}

function initAbout() {
    debugLog('About page initialization started');
    
    var animateAbout = {
        distance: '0px',
        duration: 1100,
        scale: 1,
        easing: 'ease'
    };

    window.sr = ScrollReveal();
    window.sr.reveal('.about-person', animateAbout);
    window.sr.reveal('.investors-img_item', animateAbout);

    // Debug investors section
    const investorsSection = document.querySelector('.investors');
    if (investorsSection) {
        debugLog('Investors section found:', investorsSection);
        
        // Check for investor images
        const investorImages = investorsSection.querySelectorAll('.investors-img_item img');
        debugLog('Investor images found:', investorImages.length);
        
        investorImages.forEach((img, index) => {
            debugLog(`Investor ${index + 1}:`, {
                src: img.src,
                alt: img.alt,
                visible: img.offsetWidth > 0 && img.offsetHeight > 0,
                loaded: img.complete && img.naturalHeight !== 0
            });
        });
        
        // Check ScrollReveal elements
        const srElements = investorsSection.querySelectorAll('.sr .fooReveal');
        debugLog('ScrollReveal elements in investors:', srElements.length);
        
    } else {
        debugLog('Investors section NOT found');
    }

    // Debug team section
    const teamSections = document.querySelectorAll('.about-team');
    debugLog('Team sections found:', teamSections.length);
    
    teamSections.forEach((section, index) => {
        const title = section.querySelector('.about-team_title');
        const members = section.querySelectorAll('.about-person');
        debugLog(`Team section ${index + 1}:`, {
            title: title ? title.textContent : 'No title',
            memberCount: members.length
        });
    });

    $('.about-person').on('click keyup', function (e) {
        if (e.type === 'keyup' && e.which !== 13) return;
        var name = e.target.dataset.about || this.dataset.about;
        if (!name) return;

        var $modal = $(".modal[data-about='" + name + "']");
        $modal.addClass('show').css({ display: 'flex' });
        $('body').addClass('no-scroll');
    });

    $('.swiper-slide_button').on('click', function (e) {
        var about = e.target.dataset.about || this.dataset.about;
        if (!about) return;
        $(".modal[data-about='" + about + "']").addClass('show').css({ display: 'flex' });
        $('body').addClass('no-scroll');
    });

    $('.modal').on('click', function (e) {
        if (e.target === this) {
            $(this).fadeOut(300);
            $('body').removeClass('no-scroll');
        }
    });

    $('.modal-close').on('click', function () {
        $('.modal').fadeOut(300);
        $('body').removeClass('no-scroll');
    });

    $('.swiper-container').each(function (index) {
        var sliderNum = index + 1;
        new Swiper('.swiper-' + sliderNum, {
            pagination: {
                el: '.swiper-pagination-' + sliderNum,
                clickable: true
            },
            spaceBetween: 30
        });
    });

    var $lastAboutList = $('.about-list').last();
    $lastAboutList.append($('#joinTeamOdd'));

    function syncJoinTeamState() {
        var joinTeam = document.getElementById('joinTeam');
        var joinTeamOdd = document.getElementById('joinTeamOdd');
        if (!joinTeam || !joinTeamOdd || !$lastAboutList.length) return;

        if (window.matchMedia('(min-width: 767px)').matches) {
            var items = $lastAboutList.find('.about-person');
            if ((items.length % 2) === 0) {
                joinTeam.style.display = 'flex';
                joinTeamOdd.style.display = 'none';
            } else {
                joinTeam.style.display = 'none';
                joinTeamOdd.style.display = 'flex';
            }
        } else {
            joinTeam.style.display = 'flex';
        }
    }

    syncJoinTeamState();
    window.addEventListener('resize', syncJoinTeamState);
}

function sortNewsByDate() {
    var featuredContainer = document.querySelector('.news-featured .swiper-wrapper');
    if (featuredContainer) {
        var featuredSlides = Array.from(featuredContainer.querySelectorAll('.swiper-slide'));
        featuredSlides.sort(function (a, b) {
            var da = new Date((a.querySelector('time') || {}).textContent || 0);
            var db = new Date((b.querySelector('time') || {}).textContent || 0);
            return db - da;
        });
        featuredSlides.forEach(function (slide) {
            featuredContainer.appendChild(slide);
        });
    }

    var newsContainer = document.querySelector('.news');
    if (newsContainer) {
        var items = Array.from(newsContainer.querySelectorAll('.news-animate'));
        items.sort(function (a, b) {
            var da = new Date(((a.querySelector('time') || {}).getAttribute || function () { return ''; }).call(a.querySelector('time'), 'datetime') || 0);
            var db = new Date(((b.querySelector('time') || {}).getAttribute || function () { return ''; }).call(b.querySelector('time'), 'datetime') || 0);
            return db - da;
        });
        items.forEach(function (item) {
            newsContainer.appendChild(item);
        });
    }
}

function initNews() {
    console.log('News page initialization started');
    
    var animateNews = {
        distance: '0px',
        duration: 1100,
        scale: 1,
        easing: 'ease'
    };

    window.sr = ScrollReveal();
    window.sr.reveal('.news-animate', animateNews);

    sortNewsByDate();

    console.log('Checking Swiper elements:');
    console.log('- Swiper container exists:', $('.news-featured').length);
    console.log('- Next button exists:', $('.swiper-button-next').length);
    console.log('- Prev button exists:', $('.swiper-button-prev').length);
    console.log('- Pagination exists:', $('.news-featured_pagination').length);

    console.log('Creating Swiper for news-featured');
    var newsSwiper = new Swiper('.news-featured', {
        pagination: {
            el: '.news-featured_pagination',
            clickable: true
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        spaceBetween: 45,
        loop: true
    });
    
    // Add manual click handlers as fallback
    $('.swiper-button-next').on('click', function(e) {
        e.preventDefault();
        console.log('Next button clicked');
        if (newsSwiper) {
            newsSwiper.slideNext();
        }
    });
    
    $('.swiper-button-prev').on('click', function(e) {
        e.preventDefault();
        console.log('Prev button clicked');
        if (newsSwiper) {
            newsSwiper.slidePrev();
        }
    });
    
    console.log('News Swiper created:', newsSwiper);
    console.log('News page initialization complete');
}

function numberWithCommas(x) {
    if (x === null || x === undefined) return '';
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function initCalculator() {
    console.log('Calculator init function called');
    debugLog('Initializing calculator');
    
    // Check each prerequisite individually
    var hasSlider = ensurejQueryPlugin('slider');
    var hasDeviceSlider = safeQuery('#slider-device-number').length;
    var hasCostSlider = safeQuery('#slider-cost-per-devices').length;
    
    console.log('Prerequisites check:');
    console.log('- jQuery UI slider plugin available:', hasSlider);
    console.log('- Device slider element exists:', hasDeviceSlider);
    console.log('- Cost slider element exists:', hasCostSlider);
    
    if (!hasSlider || !hasDeviceSlider || !hasCostSlider) {
        console.log('Calculator prerequisites not met');
        debugLog('Calculator prerequisites not met');
        return;
    }

    console.log('Calculator prerequisites met, creating sliders');
    var softwareValue = 40000;
    var hardwareValue = 1000;
    var $softwareBox = safeQuery('.price-software-wrapper');
    var $ctaCalculate = safeQuery('.price-card-container-footer');

    function getResults(numDevices, costPerDevice) {
        var fixedCost = 80;
        var saving = costPerDevice * numDevices - fixedCost * numDevices;
        var percentage = ((saving / (costPerDevice * numDevices)) * 100).toFixed(2);
        return { saving: saving, percentage: percentage };
    }

    function showResults() {
        var result = getResults(softwareValue, hardwareValue);
        safeQuery('#software-cost').html(numberWithCommas(result.percentage) + '%');
        safeQuery('#hardware-cost').html('$' + numberWithCommas(result.saving));
    }

    var throttledShow = throttle(showResults, 100);

    console.log('Creating device slider');
    safeQuery('#slider-device-number').slider({
        range: 'min',
        min: 10000,
        max: 1000000,
        step: 1000,
        value: softwareValue,
        slide: function (_event, ui) {
            softwareValue = ui.value;
            safeQuery('#device').html(numberWithCommas(ui.value));
            throttledShow();
        }
    });

    safeQuery('#slider-device-number .ui-slider-handle').eq(0).append('<b class="amount"><span id="device">' + numberWithCommas(softwareValue) + '</span></b>');

    console.log('Creating cost slider');
    safeQuery('#slider-cost-per-devices').slider({
        range: 'min',
        min: 250,
        max: 3000,
        step: 250,
        value: hardwareValue,
        slide: function (_event, ui) {
            hardwareValue = ui.value;
            safeQuery('#price').html('$' + numberWithCommas(ui.value));
            throttledShow();
        }
    });

    safeQuery('#slider-cost-per-devices .ui-slider-handle').eq(0).append('<b class="amount"><span id="price">$' + numberWithCommas(hardwareValue) + '</span></b>');

    safeQuery('#cta-calculate-price').on('click', function (event) {
        event.preventDefault();
        $softwareBox.addClass('show').css({ display: 'grid' });
        showResults();
        $ctaCalculate.hide();
    });

    console.log('Calculator initialized successfully');
    debugLog('Calculator initialized');
}

function initLandingModals() {
    function closeLandingModals() {
        $('.modal').removeClass('show').css({ display: 'none' });
        $('body').removeClass('no-scroll');
        // Reset embedded videos so playback stops when the modal is dismissed
        $('.modal iframe').each(function () {
            this.src = this.src;
        });
    }

    $('#cta-open-contact-us').on('click', function (event) {
        event.preventDefault();
        var target = $(this).attr('href');
        $(target).addClass('show').css({ display: 'flex' });
        $('body').addClass('no-scroll');
    });

    $('.play-button').on('click', function (event) {
        event.preventDefault();
        var target = $(this).attr('href');
        $(target).addClass('show').css({ display: 'flex' });
        $('body').addClass('no-scroll');
    });

    $('.modal').on('click', function (event) {
        if (event.target && String(event.target.id).startsWith('modal-')) {
            closeLandingModals();
        }
    });

    $('.modal-close').on('click', function (event) {
        event.preventDefault();
        closeLandingModals();
    });
}

function initContactModalForm() {
    var $form = $('#contact-form');
    if (!$form.length || !$.validator) return;

    $form.validate({
        rules: {
            contact_name: { required: true, minlength: 1, maxlength: 100, fullname: true },
            contact_email: { required: true, emailAddress: true, businessAccount: true },
            contact_phone: { required: true },
            contact_business: { required: true, minlength: 3, maxlength: 100 }
        },
        errorElement: 'span'
    });

    $form.on('submit', function (event) {
        event.preventDefault();
        if (!$form.valid()) return false;

        submitAjaxForm($form, MODAL_FORM_ENDPOINT, function () {
            $form[0].reset();
            $('.modal-close').trigger('click');
            window.location.href = '/thank-you/';
        });

        return false;
    });
}

function initLanding() {
    initCalculator();
    initLandingModals();
    initContactModalForm();
    initFaqAccordion();
    initLottieAnimation();
    initClientTabs();
}

function initClientTabs() {
    safeQuery('.clients-tabs-titles-button a').on('click', function (e) {
        e.preventDefault();
        
        var $this = $(this);
        var targetId = $this.data('target');
        
        if (!targetId) return;
        
        // Remove active class from all tabs and contents
        safeQuery('.clients-tabs-titles-button').removeClass('active');
        safeQuery('.clients-tabs-item').removeClass('visible-tab');
        
        // Add active class to clicked tab and corresponding content
        $this.closest('.clients-tabs-titles-button').addClass('active');
        safeQuery(targetId).addClass('visible-tab');
        
        debugLog('Tab switched to:', targetId);
    });
    
    debugLog('Client tabs initialized');
}

function initLottieAnimation() {
    const LottieContainer = document.getElementById('LottieContainer');
    if (LottieContainer) {
        let lottieAnimation = lottie.loadAnimation({
            container: LottieContainer,
            path: '../assets/lottie/cards.json',
            renderer: 'svg',
            loop: true,
            autoplay: true
        });
        debugLog('Lottie animation initialized');
    } else {
        debugLog('LottieContainer not found');
    }
}

function initFaqAccordion() {
    safeQuery('.accordion-item-head').on('click', function (e) {
        e.preventDefault();
        var $head = $(this);
        var $item = $head.closest('.accordion-item');
        var $content = $item.find('.accordion-item-content');
        var isActive = $item.hasClass('active');

        // Close all other items
        safeQuery('.accordion-item').removeClass('active');
        safeQuery('.accordion-item-content').slideUp(300);

        // Open this item if it wasn't active
        if (!isActive) {
            $item.addClass('active');
            $content.slideDown(300);
        }
    });

    debugLog('FAQ accordion initialized');
}

function initContactPage() {
    var $form = $('#mainForm');
    if ($form.length && $.validator) {
        $form.validate({
            rules: {
                name: { required: true, minlength: 1, maxlength: 100 },
                email: { required: true, emailAddress: true, businessAccount: true },
                phone: { required: true },
                business: { required: true, minlength: 3, maxlength: 100 }
            },
            errorElement: 'span'
        });

        $form.on('submit', function (event) {
            event.preventDefault();
            if (!$form.valid()) return false;

            submitAjaxForm($form, FORM_ENDPOINT, function () {
                window.location.href = '/thank-you/';
            });

            return false;
        });
    }

    if (window.matchMedia('(min-width: 991px)').matches) {
        $('.map-item').on('mouseenter', function () {
            var mapKey = this.dataset.mapa;
            $('.' + mapKey + '-img').slideUp();
            $('.' + mapKey + '-link').removeClass('cloak').addClass('show');
        }).on('mouseleave', function () {
            var mapKey = this.dataset.mapa;
            $('.' + mapKey + '-img').slideDown();
            $('.' + mapKey + '-link').removeClass('show').addClass('cloak');
        });
    } else {
        $('.map-item_cta').removeClass('cloak');
        $('.map-item_logo').hide();
    }
}

function initRequestDemoPage() {
    debugLog('Initializing request demo page');
    
    var $form = safeQuery('#sa-request-demo-form');
    if (!$form.length || !ensureLib('jQuery Validation', $.validator)) {
        debugLog('Request demo page prerequisites not met', { formExists: $form.length, validatorExists: !!$.validator });
        return;
    }

    debugLog('Setting up validation for request demo form');
    
    // Initialize validation
    $form.validate({
        validationTrigger: 'submit',
        rules: {
            name: { required: true, minlength: 1, maxlength: 100 },
            email: { required: true, emailAddress: true, businessAccount: true },
            business: { required: true, minlength: 3, maxlength: 100 }
        },
        errorElement: 'span'
    });
    
    // Handle form submission
    $form.on('submit', function (event) {
        debugLog('Request demo form submitted - preventing default');
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        
        if (!$form.valid()) {
            debugLog('Form validation failed');
            return false;
        }

        debugLog('Form validation passed, submitting via AJAX');
        submitAjaxForm($form, FORM_ENDPOINT, function () {
            debugLog('Form submitted successfully, redirecting');
            window.location.href = '/thank-you/';
        });

        return false;
    });

    debugLog('Request demo page initialized');
}

function initAll() {
    debugLog('Initializing MagicCube JS');
    debugLog('Body classes', getBodyClasses());

    addValidationMethods();
    initGlobalMenus();
    initGlobalOverlayForms();

    if (hasPageClass('page-home')) {
        debugLog('Detected home page');
        initHome($('body'));
    }

    if (hasPageClass('page-about') || hasPageClass('page-page-about')) {
        debugLog('Detected about page');
        initAbout();
    } else {
        debugLog('About page not detected');
    }

    if (hasPageClass('page-news')) {
        initNews();
    }

    if (hasPageClass('page-landing')) {
        initLanding();
    }

    if (hasPageClass('page-contact')) {
        initContactPage();
    }

    if (hasPageClass('page-request-demo')) {
        initRequestDemoPage();
    }

    debugLog('MagicCube JS initialization complete');
}

initWhenReady('MagicCube', initAll);

// Global error handler for debugging
if (DEBUG) {
    window.addEventListener('error', function (e) {
        debugLog('Global error', { message: e.message, filename: e.filename, lineno: e.lineno });
    });
    window.addEventListener('unhandledrejection', function (e) {
        debugLog('Unhandled promise rejection', e.reason);
    });
}